module.exports = __webpack_public_path__ + "asset/image-no-events-469227c729b22aeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-list-modal/image/no-events.svg
// module id = HGZV
// module chunks = 0